<template>
  <div class="page-box">
    <Header />
    <JiuciContent />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import JiuciContent from './JiuciContent.vue'
export default {
  name: "NineToken",
  components: {
    Header,
    Footer,
    JiuciContent
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
